export enum EUtilizacaoServidorEmailNotificacao {
  NotificacoesGerais = 1,
  NotificacoesCobranca = 2,
  ControleUsuario = 3
}
